<template>
	<div class="fight-intro">
		<div class="fight-intro__header">
			<div class="fight-intro__header__text">
				{{ translate("ui.enemy_territory") }}
			</div>
		</div>
		<div class="fight-intro__content">
			<div>
				{{ translate("ui.enemy_territory.about_1") }}
			</div>
			<div>
				{{ translate("ui.enemy_territory.about_2") }}
			</div>
			<div>
				{{ translate("ui.enemy_territory.about_3") }}
			</div>
		</div>

		<AppTextButton
			class="fight-intro__popup__btn"
			:type="StatusTypes.WARNING"
			:text="translate('button.continue')"
			@click="nextPage"
		/>
		<div class="fight-intro__pagination">1/2</div>
		<GoldenCorner bottom left />
		<GoldenCorner bottom right />
	</div>
</template>

<script lang="ts" setup>
import AppTextButton from "@/components/AppTextButton.vue";
import { PopupType, usePopupStore } from "@/store/usePopupStore.ts";
import { SkinTypes, StatusTypes } from "@/types/ui.ts";
import { translate } from "@/utils/translate.ts";
import { markRaw } from "vue";
import GoldenCorner from "../SVG/GoldenCorner.vue";
import FightTutorialPopup from "./FightTutorialPopup.vue";

const popupStore = markRaw(usePopupStore());

const nextPage = (): void => {
	popupStore.hidePopup();
	popupStore.showPopup({
		type: PopupType.NO_DIVIDER,
		heading: translate("ui.how_to_play"),
		skin: SkinTypes.DARK,
		isPaddingless: true,
		isCentered: true,
		isPriority: true,
		height: 31,
		width: 23.875,
		component: markRaw(FightTutorialPopup),
	});
};
</script>

<style lang="scss" scoped>
.fight-intro {
	gap: 0.5rem;
	border-width: 0.125rem;
	border-style: solid;
	border-image-source: linear-gradient(to top, #bd9032, #f0d386);
	border-image-slice: 1;
	width: 100%;
	height: 100%;
	@include flex-col-start;
	position: relative;
	background-image: linear-gradient(
		to top,
		rgb(27, 50, 76),
		rgb(42, 80, 124)
	);

	&::before {
		position: absolute;
		top: 0;
		left: 0;
		opacity: 1;
		mix-blend-mode: multiply;
		background: url($path-images + "backgrounds/textures/marble-texture-bg.avif")
			repeat center;
		background-size: 40%;
		width: 100%;
		height: 100%;
		content: "";
	}
	&__header {
		background-image: url($path-images + "backgrounds/fight-system/about-img.avif");
		background-size: cover;
		width: 100%;
		height: 10.975rem;
		@include flex-col-end;
		margin-bottom: 1.5rem;

		&__text {
			display: flex;
			position: fixed;
			top: 9.975rem;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			background-image: url($path-images + "backgrounds/fight-system/ribbon.avif");
			background-size: contain;
			background-repeat: no-repeat;
			padding-bottom: 1.25rem;
			width: 103%;
			height: 4.125rem;
			color: rgb(244, 210, 120);
			font-weight: 900;
			font-size: 1.25rem;
			text-shadow: 0.0437rem 0.0437rem 0.0625rem rgba(0, 0, 0, 0.6);
			text-transform: uppercase;
		}
	}
	&__content {
		padding: 1rem;
		color: rgb(242, 220, 181);
		font-size: 0.9063rem;
		line-height: 1.35;
		text-shadow: 0.0437rem 0.0437rem 0.0625rem rgba(0, 0, 0, 0.6);
		@include flex-col-center;
	}
	&__pagination {
		padding-bottom: 0.5rem;
		color: rgb(242, 220, 181);
		font-size: 0.9063rem;
		text-shadow: 0.0437rem 0.0437rem 0.0625rem rgba(0, 0, 0, 0.6);
	}
	:deep(.golden-corner) {
		width: 1.5rem;
		height: 1.5rem;
	}

	:deep(.golden-corner--bottom-left) {
		position: absolute;
		bottom: -0.125rem;
		left: -0.125rem;
	}

	:deep(.golden-corner--bottom-right) {
		position: absolute;
		right: -0.125rem;
		bottom: -0.125rem;
	}
}
</style>
